import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/index.vue";
import HomeLite from "../views/home/home-lite.vue";
import Knowledge from "../views/knowledge/index.vue";
import KnowledgeLite from "../views/knowledge/knowledge-lite.vue";
const TOKEN_KEY = 'MDZH_SAAS_AUTH_X_TOKEN'
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "homeLite",
    component: HomeLite,
  },
  {
    path: "/research-visualization-full",
    name: "researchVisualizationFull",
    component: Home,
  },
  {
    path: "/knowledge",
    name: "knowledgeLite",
    component: KnowledgeLite,
  },
  {
    path: "/intellectual-property-knowledge-full",
    name: "intellectualPropertyKnowledgeFull",
    component: Knowledge,
  },
];
const router = new VueRouter({
  mode: "hash",
  routes,
});

// 添加路由守卫，检查URL参数中的token并存储到localStorage
router.beforeEach((to, from, next) => {
  // 检查路由参数中是否有token
  if (to.query.token) {
    // 将token存储到localStorage
    localStorage.setItem(TOKEN_KEY, to.query.token);
    next()
  }
  
  next();
});

export default router;
